module.exports = __webpack_public_path__ + "img/Foto-2.ab4ec838.jpg";